const FormRow = ({ children, className, ...rest }) => {
  return <div className={`flex flex-row gap-4 ${className}`} {...rest}>{children}</div>;
};

export default FormRow;
